const DRAFT_KEY = 'providerSignupDraft';

export function saveSignupDraft(draft) {
  try {
    sessionStorage.setItem(DRAFT_KEY, JSON.stringify(draft));
  } catch (err) {
    console.warn('Could not save signup draft:', err);
  }
}

export function loadSignupDraft() {
  try {
    const raw = sessionStorage.getItem(DRAFT_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function clearSignupDraft() {
  sessionStorage.removeItem(DRAFT_KEY);
}
